<template>
  <div style="width: 100%">
    <v-container>
      <v-row v-if="loadingPage" class="d-flex justify-center">
        <custom-loading></custom-loading>
      </v-row>
      <v-row v-else>
        <autoservicio-group
          v-for="(processGroup, idx) in processGroups"
          :key="idx"
          :id="'autoservicioListGroups' + idx"
          :processGroup="processGroup"
        >
        </autoservicio-group>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import uris from '../../../utils/uris'
import axios from '../../../utils/axiosWrapperAutoservicio'
import AutoservicioGroup from './autoservicio-group.vue'
import CustomLoading from '../../custom-loading.vue'

export default {
  name: 'autoservicio-list-groups',
  data () {
    return {
      loadingPage: true,
      processGroups: []
    }
  },
  components: {
    AutoservicioGroup,
    CustomLoading
  },
  methods: {
    getStructure () {
      axios.post(uris.URL_AUTOSERVICIO_GET_GROUPS)
        .then((response) => {
          this.processGroups = response.data
        })
        .catch((err) => {
          console.warn('No se ha podido obtener data del autoservicio', err)
        })
        .finally(() => {
          this.loadingPage = false
        })
    }
  },
  props: {
  },
  computed: {
  },
  mounted () {
    this.getStructure()
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/autoservicios/groups/autoservicio-list-groups.vue